// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3-4gd","subheader":"ReorderModal_subheader__1G7zG","listWrap":"ReorderModal_listWrap__IWWDN"};